import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .job-board-listing-select {
      --tenable-input-width: auto;
      --tenable-input-border: none;
      --tenable-input-border-radius: 0px;
      --tenable-input-box-shadow: 0px;
      --tenable-input-padding: .5rem .1rem .5rem 0rem;
    }

    .job-board-card {
      border-bottom: var(--tenable-job-listing-card-border, 1px solid #ccc);
    }

    .sort-by {
      border-bottom: var(--tenable-job-listing-card-border, 1px solid #ccc);
    }
  `,
];
